const LOCAL_API_URL = 'http://localhost:3001';
const PRODUCTION_API_URL = 'https://localguruconnect-backend.vercel.app';
const DEFAULT_API_URL = process.env.NODE_ENV === 'production' ? PRODUCTION_API_URL : LOCAL_API_URL;

const trimTrailingSlashes = (value: string) => value.replace(/\/+$/, '');

export const API_URL = trimTrailingSlashes((process.env.REACT_APP_API_URL || '').trim() || DEFAULT_API_URL);

const isCapacitorRuntime = () =>
  typeof window !== 'undefined' &&
  (window.location.protocol === 'capacitor:' ||
    window.location.protocol === 'ionic:' ||
    (window.location.protocol === 'https:' && window.location.hostname === 'localhost' && !window.location.port));

const isLoopbackApiUrl = (value: string) => {
  try {
    const url = new URL(value);
    return ['localhost', '127.0.0.1', '10.0.2.2'].includes(url.hostname);
  } catch {
    return false;
  }
};

if (process.env.NODE_ENV === 'production' && isCapacitorRuntime() && isLoopbackApiUrl(API_URL)) {
  console.warn(
    'Capacitor production build is using a loopback API URL. Set REACT_APP_API_URL to a reachable HTTPS backend before building the mobile app.',
  );
}
